import { Mutation } from 'vuex';
import { IModuleState } from './types';

// 列表
export const setProperties: Mutation<IModuleState> = (state, payload) => {
  state.list.data = payload.data;
  state.list.loading = !!payload.loading;
};

// 详情
export const setPropertyDetail: Mutation<IModuleState> = (state, payload) => {
  state.detail.data = payload.data;
  state.detail.loading = !!payload.loading;
};

// 选项
export const setPropertyOptions: Mutation<IModuleState> = (state, payload) => {
  state.options.data = payload.data;
  state.options.loading = !!payload.loading;
};

export const setDialog: Mutation<IModuleState> = (state, payload) => {
  state.dialog.data = payload.data || null;
  state.dialog.title = payload.title;
  state.dialog.type = payload.type;
  state.dialog.visible = !!payload.visible;
  state.dialog.loading = !!payload.loading;
};

export const setConfirm: Mutation<IModuleState> = (state, payload) => {
  state.confirm.title = payload.title;
  state.confirm.content = payload.content;
  state.confirm.visible = !!payload.visible;
  state.confirm.loading = !!payload.loading;
};

export const setLoading: Mutation<IModuleState> = (state, payload) => {
  state.loading = payload;
};
